"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.noopLogger = exports.leveledLogger = void 0;
const noopLogger = exports.noopLogger = {
  debug: (_message, ..._optionalParams) => {},
  info: (_message, ..._optionalParams) => {},
  warn: (_message, ..._optionalParams) => {},
  error: (_message, ..._optionalParams) => {}
};
const leveledLogger = (level, logger) => {
  const res = noopLogger;
  res.error = logger.error;
  if (level === "error") {
    return res;
  }
  res.warn = logger.warn;
  if (level === "warn") {
    return res;
  }
  res.info = logger.info;
  if (level === "info") {
    return res;
  }
  res.debug = logger.debug;
  return res;
};
exports.leveledLogger = leveledLogger;
//# sourceMappingURL=Logger.js.map